import { Box, BoxProps, Typography } from '@mui/material';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { BoxRow } from 'src/components/BoxRow';
import { ManageVideosIcon } from 'src/components/icons';
import { maybeCall } from 'src/utils/common';
import { UserNotification } from '../types';

interface Props {
  notification: UserNotification;
  onClick?: () => void;
  sx?: BoxProps['sx'];
}

export const NotificationItem = ({ onClick, notification, sx }: Props) => {
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    maybeCall(onClick);

    if (notification.video) {
      navigate(`/video/${notification.video.id}`);
    }
  }, [notification]);

  return (
    <BoxRow
      onClick={handleClick}
      sx={{ ...sx, alignItems: 'center', cursor: 'pointer' }}
    >
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: '#356482',
          borderRadius: '5px',
          display: 'flex',
          height: '40px',
          justifyContent: 'center',
          width: '40px',
        }}
      >
        {notification.video ? (
          <ManageVideosIcon stroke="white" sx={{ fontSize: '20px' }} />
        ) : null}
      </Box>
      <Box sx={{ display: 'flex', flex: 1 }}>
        <Typography
          fontWeight="regular"
          sx={{
            color: '#356482',
            fontSize: '14px',
            overflow: 'hidden',
            paddingLeft: '15px',
            textOverflow: 'ellipsis',
            width: '100%',
            wordBreak: 'break-word',
          }}
        >
          {notification.from.firstName} {notification.from.lastName} shared a video{' '}
          {notification.video?.title}
        </Typography>
      </Box>
    </BoxRow>
  );
};
